module.exports = __webpack_public_path__ + "img/polar_bear_small.ad9b85bf.png";